// Environment configuration
// Use relative URLs when served through IIS proxy, or full URLs for direct access
const getApiUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL
  
  // In production (when served from uatcytest.cyfuture.com), use relative URLs
  // This will work with IIS proxy rewrite rules
  if (window.location.hostname.includes('uatcytest.cyfuture.com') || 
      window.location.hostname.includes('cyfuture.com')) {
    return '/api/v1' // Use relative URL for IIS proxy
  }
  
  // For development, use environment variable or default
  if (envUrl && !envUrl.startsWith('/')) {
    // Replace port 8000 with 8443 if present
    const updatedUrl = envUrl.replace(':8000', ':8443')
    return updatedUrl
  }
  
  // If no env URL or relative, use relative path (works with IIS proxy)
  return envUrl || '/api/v1'
}

const getWsUrl = () => {
  const envUrl = import.meta.env.VITE_WS_URL

  // For production (when served from uatcytest.cyfuture.com), force relative URL so IIS proxy handles it
  if (window.location.hostname.includes('uatcytest.cyfuture.com') || 
      window.location.hostname.includes('cyfuture.com')) {
    return '/ws'
  }

  if (envUrl && !envUrl.startsWith('/')) {
    // Replace port 8000 with 8443 if present (production fix)
    const updatedUrl = envUrl.replace(':8000', ':8443')
    return updatedUrl
  }

  // For production (when served from uatcytest.cyfuture.com), use relative URL so IIS handles proxying
  // For WebSocket, use wss:// for HTTPS or ws:// for HTTP
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return envUrl || `${protocol}//${window.location.host}/ws`
}

export const config = {
  API_URL: getApiUrl(),
  WS_URL: getWsUrl(),
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Cytest',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  DEBUG: import.meta.env.DEV || false,
}
